document.addEventListener('DOMContentLoaded', function() {
  const stickyCart = document.getElementById('stickyCart');
  const originalForm = document.querySelector('.js-product-form');
  const stickyForm = document.querySelector('.sticky-cart-form');
  const stickyVariantInput = document.querySelector('.sticky-variant-id');
  const stickyQuantityInput = document.querySelector('.sticky-quantity');
  const stickyBtn = document.getElementById('stickyAddToCartBtn');
  
  if (!stickyCart || !originalForm) return;
  
  // Update sticky cart when variant changes
  function updateStickyCart() {
    const selectedVariant = originalForm.querySelector('[name="id"]');
    const quantityInput = originalForm.querySelector('[name="quantity"]');
    const originalBtn = originalForm.querySelector('.add-to-cart');
    
    // Update variant ID
    if (selectedVariant && selectedVariant.value) {
      stickyVariantInput.value = selectedVariant.value;
    }
    
    // Update quantity
    if (quantityInput && stickyQuantityInput) {
      stickyQuantityInput.value = quantityInput.value || 1;
    }
    
    // Update button state and text dynamically
    if (originalBtn) {
      stickyBtn.disabled = originalBtn.disabled;
      
      const btnTextElement = stickyBtn.querySelector('.btn-text');
      if (btnTextElement) {
        // Copy the exact text from the original button
        btnTextElement.textContent = originalBtn.textContent.trim();
      }
      
      // Copy button styles if needed (optional)
      if (originalBtn.disabled) {
        stickyBtn.style.opacity = '0.5';
        stickyBtn.style.cursor = 'not-allowed';
      } else {
        stickyBtn.style.opacity = '1';
        stickyBtn.style.cursor = 'pointer';
      }
    }
  }
  
  // Show/hide sticky cart based on scroll position
  function toggleStickyCart() {
    const buyButtons = document.querySelector('.buy-buttons-row');
    if (!buyButtons) return;
    
    const buyButtonsRect = buyButtons.getBoundingClientRect();
    
    if (buyButtonsRect.bottom < 100) {
      stickyCart.classList.add('show');
    } else {
      stickyCart.classList.remove('show');
    }
  }
  
  // Listen for variant changes
  document.addEventListener('change', function(e) {
    if (e.target.closest('.js-product-form')) {
      setTimeout(updateStickyCart, 100);
    }
  });
  
  // Listen for quantity changes
  document.addEventListener('click', function(e) {
    if (e.target.matches('[data-quantity]')) {
      setTimeout(updateStickyCart, 100);
    }
  });
  
  // Listen for scroll events
  window.addEventListener('scroll', toggleStickyCart);
  
  // Watch for text changes in the original button (for dynamic updates)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        const originalBtn = originalForm.querySelector('.add-to-cart');
        if (originalBtn && mutation.target.closest('.add-to-cart')) {
          updateStickyCart();
        }
      }
    });
  });
  
  // Start observing the original form for changes
  const originalBtn = originalForm.querySelector('.add-to-cart');
  if (originalBtn) {
    observer.observe(originalBtn, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
  
  // Initialize
  updateStickyCart();
  
  // Handle sticky form submission
  stickyForm.addEventListener('submit', function(e) {
    e.preventDefault();
    
    const formData = new FormData();
    
    // Add variant ID
    formData.append('id', stickyVariantInput.value);
    
    // Add quantity if available
    if (stickyQuantityInput) {
      formData.append('quantity', stickyQuantityInput.value);
    }
    
    // Add other form fields from original form
    const originalInputs = originalForm.querySelectorAll('input[type="hidden"], select');
    originalInputs.forEach(input => {
      if (input.name && input.name !== 'id' && input.name !== 'quantity' && input.value) {
        formData.append(input.name, input.value);
      }
    });
    
    // Get cart URL from form and add .js for AJAX
    const cartAddUrl = stickyForm.getAttribute('action') + '.js';
    
    // Submit to cart
    fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: new URLSearchParams(formData)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      // Success - reload to show updated cart
      window.location.reload();
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      alert('There was an error adding the product to your cart. Please try again.');
    });
  });
});